import { ControllableProps } from '../types';
import { Controller, FieldValues } from 'react-hook-form';
import { Input, InputProps } from '@/components/form/uncontrolled/Input/Input';
import { makeUncontrolledProps } from '../utility';

export function FormInput<T extends FieldValues>({
  name,
  control,
  disabled,
  onChange,
  ...rest
}: ControllableProps<InputProps, T>) {
  const renderInput = (renderProps) => (
    <Input {...makeUncontrolledProps({ renderProps, componentProps: rest, onChange, passError: true })} />
  );

  return <Controller render={renderInput} name={name} control={control} disabled={disabled} />;
}
